function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "10.-E---apm\\u0101c\\u012Bba---T\\u0113ma-nok\\u0101rtota",
  transform: "translate(-847.000000, -418.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(294.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Video-block",
  transform: "translate(24.000000, 112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(390.500000, 236.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-check-large",
  transform: "translate(138.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32,0 C49.673112,0 64,14.326888 64,32 C64,49.673112 49.673112,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 Z",
  id: "Path",
  fill: "#2C9C3B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.5313708,27.4393398 C40.9545965,26.8986139 40.0470268,26.8570196 39.4193609,27.3145569 L39.2686292,27.4393398 L30.8,35.3775 L28.7313708,33.4393398 L28.5806391,33.3145569 C27.9529732,32.8570196 27.0454035,32.8986139 26.4686292,33.4393398 C25.8918548,33.9800658 25.8474876,34.8309124 26.3355274,35.4193492 L26.4686292,35.5606602 L29.6686292,38.5606602 L29.8193609,38.6854431 C30.3947213,39.1048523 31.2052787,39.1048523 31.7806391,38.6854431 L31.9313708,38.5606602 L41.5313708,29.5606602 L41.6644726,29.4193492 C42.1525124,28.8309124 42.1081452,27.9800658 41.5313708,27.4393398 Z",
  id: "Path",
  fill: "#F0F2F5"
})))))));

function SvgIcCheckLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-check-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckLarge);
export default __webpack_public_path__ + "static/media/ic-check-large.7679289c.svg";
export { ForwardRef as ReactComponent };